












import { getGeoOptions } from "@/models/GeoEntity.ts";
import { Vue, Component, Watch, Prop } from "vue-property-decorator";

@Component({})
export default class CountrySelect extends Vue {
  @Prop({ type: String }) value!: string;
  @Prop({ type: Array }) rules!: any[];

  private loading: boolean = false;
  private items: object[] = [];

  async created() {
    this.items = getGeoOptions();
  }

  updateValue(value: any) {
    this.$emit("input", value);
  }
}
